/**
 * HTTP Client for API requests
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from "axios";
import HttpClientResponseError from "./http-client-response-error";
export default class HttpClient {
    static get(url_1) {
        return __awaiter(this, arguments, void 0, function* (url, params = {}) {
            const response = yield axios.get(url, {
                params,
                headers: {
                    Accept: "application/json",
                },
            });
            if (response.status === 200 || response.status === 201) {
                return response.data;
            }
            if (response.status === 400) {
                throw new HttpClientResponseError(String(response.data));
            }
            return null;
        });
    }
    static post(url, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios.post(url, data, {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            });
            if (response.status === 200 || response.status === 201) {
                return response.data;
            }
            if (response.status === 400) {
                throw new HttpClientResponseError(String(response.data));
            }
            return null;
        });
    }
    static delete(url, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios.delete(url, {
                data,
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            });
            if (response.status === 200) {
                return response.data;
            }
            if (response.status === 400) {
                throw new HttpClientResponseError(String(response.data));
            }
            return null;
        });
    }
}
